import { common } from './common';
import { home } from './home';
import { about } from './about';
import { services } from './services';
import { testimonials } from './testimonials';
import { payment } from './payment';
import { info } from './info';
import { notfound } from './notfound';

export const en = {
  common,
  home,
  about,
  services,
  testimonials,
  payment,
  info,
  notfound,
};